import { Discount } from '@squareup/sq-addons-web-sdk';

import {
  ADD_DISCOUNT,
  ADD_DISCOUNT_FULFILLED,
  ADD_DISCOUNT_REJECTED,
  CLEAR_DISCOUNTS,
  CLEAR_DISCOUNTS_FULFILLED,
  CLEAR_DISCOUNTS_REJECTED,
  FETCH_DISCOUNTS,
  FETCH_DISCOUNTS_FULFILLED,
  FETCH_DISCOUNTS_REJECTED,
  REMOVE_DISCOUNT,
  REMOVE_DISCOUNT_FULFILLED,
  REMOVE_DISCOUNT_REJECTED,
  REMOVE_DISCOUNTS,
  REMOVE_DISCOUNTS_FULFILLED,
  REMOVE_DISCOUNTS_REJECTED,
  RESET_DISCOUNTS,
  RESET_REMOVE_DISCOUNTS,
  AddDiscountAction,
  AddDiscountFulfilledAction,
  AddDiscountRejectedAction,
  ClearDiscountsAction,
  ClearDiscountsFulfilledAction,
  ClearDiscountsRejectedAction,
  FetchDiscountsAction,
  FetchDiscountsFulfilledAction,
  FetchDiscountsRejectedAction,
  RemoveDiscountAction,
  RemoveDiscountFulfilledAction,
  RemoveDiscountRejectedAction,
  RemoveDiscountsAction,
  RemoveDiscountsFulfilledAction,
  RemoveDiscountsRejectedAction,
  ResetDiscountsAction,
  ResetRemoveDiscountsAction,
} from './types';

import { order as orderApi } from '@squareup/sq-addons-web-sdk';

export function addDiscount(discount: Discount): AddDiscountAction {
  return {
    type: ADD_DISCOUNT,
    payload: { discount },
  };
}

export function addDiscountFulfilled(): AddDiscountFulfilledAction {
  return {
    type: ADD_DISCOUNT_FULFILLED,
  };
}

export function addDiscountRejected(error: Error): AddDiscountRejectedAction {
  return {
    type: ADD_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function clearDiscounts(): ClearDiscountsAction {
  return {
    type: CLEAR_DISCOUNTS,
  };
}

export function clearDiscountsFulfilled(): ClearDiscountsFulfilledAction {
  return {
    type: CLEAR_DISCOUNTS_FULFILLED,
  };
}

export function clearDiscountsRejected(
  error: Error
): ClearDiscountsRejectedAction {
  return {
    type: CLEAR_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function fetchDiscounts(): FetchDiscountsAction {
  return {
    type: FETCH_DISCOUNTS,
  };
}

export function fetchDiscountsFulfilled(
  availableDiscounts: Discount[],
  appliedDiscounts: Discount[],
  unavailableDiscounts: string[],
  updatedDiscounts: Discount[]
): FetchDiscountsFulfilledAction {

  return {
    type: FETCH_DISCOUNTS_FULFILLED,
    payload: {
      availableDiscounts,
      appliedDiscounts,
      unavailableDiscounts,
      updatedDiscounts,
    },
  };
}

export function fetchDiscountsRejected(
  error: Error
): FetchDiscountsRejectedAction {
  return {
    type: FETCH_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function removeDiscount(discount: Discount): RemoveDiscountAction {
  return {
    type: REMOVE_DISCOUNT,
    payload: { discount },
  };
}

export function removeDiscountFulfilled(): RemoveDiscountFulfilledAction {
  return {
    type: REMOVE_DISCOUNT_FULFILLED,
  };
}

export function removeDiscountRejected(
  error: Error
): RemoveDiscountRejectedAction {
  return {
    type: REMOVE_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function removeDiscounts(discountIds: string[]): RemoveDiscountsAction {
  return {
    type: REMOVE_DISCOUNTS,
    payload: { discountIds },
  };
}

export function removeDiscountsFulfilled(): RemoveDiscountsFulfilledAction {
  return {
    type: REMOVE_DISCOUNTS_FULFILLED,
  };
}

export function removeDiscountsRejected(
  error: Error
): RemoveDiscountsRejectedAction {
  return {
    type: REMOVE_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function resetRemoveDiscounts(): ResetRemoveDiscountsAction {
  return {
    type: RESET_REMOVE_DISCOUNTS,
  };
}

export function resetDiscounts(): ResetDiscountsAction {
  return {
    type: RESET_DISCOUNTS,
  };
}
